<script>
import BasicInfro from '@views/AgentList/details/basic-info.vue'
import MessageInfo from '@views/AgentList/details/message-info.vue'
import Question from '@views/AgentList/details/question.vue'
import {
  agentDetailsComputed,
  agentDetailsMethods,
} from '@state/helpers/agent-details'

import { ROLE, STATUS_REQUEST } from '@utils/constant'

export default {
  page: {
    title: 'Agent Detail',
    meta: [{ name: 'description', content: 'The Agent Detail page.' }],
  },
  components: {
    BasicInfro,
    MessageInfo,
    Question,
  },
  data() {
    return {
      show: false,
      triggerMask: false,
    }
  },
  computed: {
    ...agentDetailsComputed,
  },
  watch: {
    // watch status request edit api
    getEditStatus() {
      // if edit success call api details and remove mask
      if (this.getEditStatus === STATUS_REQUEST.SUCCESS) {
        this.fetchingDetail()
        this.triggerMask = false
      }
    },
  },
  destroyed() {
    this.resetAll()
  },
  created() {
    this.fetchingDetail()
  },
  methods: {
    ...agentDetailsMethods,
    handleTriggerMask(value) {
      this.triggerMask = value
    },
    fetchingDetail() {
      const user = this.$store.getters['auth/getCurrentUser']
      let id = null
      if (user.level === ROLE.SUPER) {
        id = this.$route.params
      } else {
        id = { id: user?.agent.id }
      }
      this.getDetailsById(id)
    },
  },
}
</script>

<template>
  <div id="agent-super-details">
    <CRow>
      <CCol lg="6">
        <BasicInfro
          :trigger-mask="triggerMask"
          @enable:edit="handleTriggerMask"
        />
        <MessageInfo
          :trigger-mask="triggerMask"
          @enable:edit="handleTriggerMask"
        />
      </CCol>
      <CCol lg="6">
        <Question
          v-for="i in [1, 2, 3, 4]"
          :key="i"
          :order="i"
          :trigger-mask="triggerMask"
          @enable:edit="handleTriggerMask"
        />
      </CCol>
    </CRow>
  </div>
</template>

<style lang="scss" scoped>
#agent-super-details {
  ::v-deep .form-group {
    margin-bottom: 0.5rem;
  }
}
</style>
